<template>
  <div class="yt-grid-table">
    <div class="d-flex justify-content-between mr-1 mb-2">
      <h1 v-if="hasTitle" v-html="title"></h1>
      <div>

        <div class="top-buttons">
          <button v-if="supportAddNew" class="btn btn-success" @click="showFormModal">
            Add New
          </button>
          <button v-if="supportImport" class="btn btn-primary" @click="onOpenImportModal" import-courses-csv>
            Import Courses
          </button>

          <button v-if="$router.currentRoute.path == '/students'" class="btn btn-primary"
            @click="onOpenImportModalForUsers">
            Import Users
          </button>
        </div>
      </div>
    </div>

    <vue-good-table class="mr-1 ml-1" mode="remote" ref="vueGoodTable" :totalRows="totalRecords" :pagination-options="{
        enabled: true,
        mode: 'pages'
      }" :rows="rows" :columns="columns" :sort-options="sortOptions" @on-page-change="onPageChange"
      @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange">
      <!-- @on-row-dblclick="onRowDoubleClick" -->
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'actions'">
          <slot name="customButtons" :props="props" :onUpdateField="onUpdateField"></slot>
          <span v-if="props.column.type == 'dinamicView'">
            <button class="btn btn-primary" @click="openDinamicViewModal(props)">
              {{ props.column.dinamicView.buttonLabel }}
            </button>
          </span>
          <button v-if="hasEditItem" class="btn btn-info" @click="showFormModal(props)">
            Edit
          </button>
          <button v-if="hasDeleteItem" class="btn btn-danger" @click="onDelete(props)">
            Delete
          </button>
        </span>
        <span v-else-if="props.column.type == 'dropdown'">
          <b-form-select v-model="props.formattedRow[props.column.field]" :options="props.column.options"
            @change="onUpdateField(props, $event)" />
        </span>
        <span v-else-if="props.column.type == 'switch'">
          <input type="checkbox" v-model="props.formattedRow[props.column.field]" @change="
              onUpdateField(props, props.formattedRow[props.column.field])
            " />
        </span>
        <span v-else-if="props.column.type == 'dinamicView'">
          <button class="btn btn-primary" @click="openDinamicViewModal(props)">
            {{ props.column.dinamicView.buttonLabel }}
          </button>
        </span>
        <span v-else-if="props.column.render">
          {{ props.column.render(props.row[props.column.field]) }}
        </span>
        <span v-else v-html="props.formattedRow[props.column.field]"></span>
      </template>
    </vue-good-table>

    <modal :name="`dinamic-view-modal-${id}`" ref="dinamicViewModal" transition="pop-out"
      :width="currentModalComponent.width" height="auto" :scrollable="true" :adaptive="true" :reset="true">
      <div class="p-2">
        <div class="card">
          <h5 class="card-header">
            {{ currentModalComponent.title }}
            <button type="button" class="close" @click="$modal.hide(`dinamic-view-modal-${id}`)">
              <span aria-hidden="true">×</span>
            </button>
          </h5>
          <div class="card-body">
            <component :is="currentModalComponent.component" v-bind="currentModalComponent.componentProps" />
          </div>
        </div>
      </div>
    </modal>

    <modal :name="`form-modal-${id}`" ref="formModal" transition="pop-out" :width="widthPopup" height="auto"
      :scrollable="true" :adaptive="true" :reset="true">
      <div class="p-2">
        <!-- <form @submit.prevent="onSaveItem()"> -->
        <div class="card">
          <h5 class="card-header">{{ modalTitle }}</h5>
          <div class="card-body">
            <!-- <h5 class="card-title">Editar</h5> -->
            <!-- <h6 class="card-subtitle mb-2 text-muted">{{ dataSelectedRow && dataSelectedRow.name }}</h6> -->
            <vue-form-generator ref="formData" :schema="schema" :model="dataSelectedRow" :options="formOptions"
              :isNewModel="isNewModel" @validated="onValidated" @model-updated="onModelUpdated"
              :class="{ add: isNewModel, edit: !isNewModel }" />
          </div>
          <div class="card-footer">
            <button class="btn btn-info" @click="onSaveItem">Save</button>
            <button class="btn btn-light" @click="hideFormModal">Close</button>
          </div>
        </div>
        <!-- </form> -->
      </div>
    </modal>

    <modal name="import-modal" transition="pop-out" :width="656" height="auto" :scrollable="true" :adaptive="true">
      <div class="p-2">
        <div class="card">
          <h5 class="card-header">Import</h5>
          <div class="card-body">
            <input type="file" ref="importFile" />

            <slot name="import_append" />
          </div>
          <div class="card-footer">
            <button class="btn btn-warning" @click="onImportFile(dataSelectedRow._id)">
              Import
            </button>
            <button class="btn btn-light" @click="$modal.hide('import-modal')">
              Close
            </button>
          </div>
        </div>
      </div>
    </modal>

    <v-dialog />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Component, Prop, Watch } from 'vue-property-decorator'
  import { namespace } from 'vuex-class'
  import PapaParse from 'papaparse'
  import qs from 'qs'
  import VueFormGenerator from 'vue-form-generator'
  const appModule = namespace('app')
 
  @Component
  export default class GridTable extends Vue {
    @appModule.State('baseUrl') baseUrlApi

    rows = []

    totalRecords = 0

    dataSelectedRow = {}

    modalTitle = 'Edit'

    baseUrl = null



    currentModalComponent = {
      width: 656,
      title: null,
      component: null,
      componentProps: {}
    }

    isValidForm = false

    isNewModel = false

    @Prop({
      type: String,
      required: true,
      default: 'gridtable'
    })
    id

    @Prop({
      type: String,
      required: false,
      default: 'Grid Table'
    })
    title

    @Prop({
      type: Boolean,
      default: true
    })
    hasTitle

    @Prop({
      type: Array,
      default: []
    })
    columns

    @Prop({
      type: Object,
      default: {}
    })
    schema

    @Prop({
      type: Object,
      default: () => {
        return {
          validateAfterLoad: true,
          validateAfterChanged: true,
          validateAsync: false,
          validateDebounceTime: 300
        }
      }
    })
    formOptions

    @Prop({
      type: String,
      default: ''
    })
    urlPath

    @Prop({
      type: Boolean,
      default: true
    })
    supportAddNew

    @Prop({
      type: Boolean,
      default: false
    })
    supportImport

    @Prop({
      type: Boolean,
      default: false
    })
    supportImportCsv

    @Prop({
      type: Boolean,
      default: true
    })
    hasEditItem

    @Prop({
      type: Boolean,
      default: true
    })
    hasDeleteItem

    @Prop({
      type: Object,
      default: () => { }
    })
    defaultServerParams

    @Prop({
      type: Function,
      required: false
    })
    filterUrlUpdate

    @Prop({
      type: Function,
      required: false
    })
    filterDataImport

    @Prop({
      type: Function,
      required: false
    })
    actionImportFile

    @Prop({
      type: Function,
      required: false
    })
    actionEndImportFile

    @Prop({
      type: Function,
      required: false
    })
    afterSaveHook

    @Prop({
      type: [String, Number],
      default: 656
    })
    widthPopup

    /* @Prop({
          type: Object,
          default: () => {
              return {
                  enabled: true,
                  initialSortBy: {}
              }
          }
      }) */
    sortOptions = {
      enabled: true,
      initialSortBy: {}
    }

    created() {
      this.baseUrl = `${this.baseUrlApi}${this.urlPath}`
    }

    mounted() {
      // this.loadItems()
      // this.baseUrl = `${this.baseUrl}`
    }

    @Watch('defaultServerParams', { immediate: true, deep: true })
    setDefaultServerParams(val) {
      this.serverParams = Object.assign({}, this.serverParams, val)

      if (this.serverParams._sort) {
        this.sortOptions.initialSortBy.field = this.serverParams._sort
      }

      if (this.serverParams._order) {
        this.sortOptions.initialSortBy.type = this.serverParams._order
      }
    }

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)

      for (let key in this.serverParams) {
        if (
          typeof this.serverParams[key] === 'string' &&
          this.serverParams[key].trim() === ''
        ) {
          delete this.serverParams[key]
        }
      }
    }

    onPageChange(params) {
      this.updateParams({ _page: params.currentPage })
      this.loadItems()
    }

    onPerPageChange(params) {
      this.updateParams({ _limit: params.currentPerPage })
      this.loadItems()
    }

    onSortChange(params, initialSort = false) {
      this.updateParams({
        _sort: params[0].field,
        _order: params[0].type
      })

      if (!initialSort) {
        this.loadItems()
      }
    }

    onColumnFilter(params) {
      this.updateParams(params.columnFilters)
      this.loadItems()
    }

    onUpdateField(props, val, fieldName = null) {
      // const updRow = { ...this.rows[props.index], [props.column.field]: val }
      const urlUpdate =
        typeof this.filterUrlUpdate === 'function'
          ? this.filterUrlUpdate(`${this.baseUrl}/${props.row._id}`, props)
          : `${this.baseUrl}/${props.row._id}`

      this.$http
        .patch(
          urlUpdate,
          qs.stringify({ [fieldName || props.column.field]: val })
        )
        .then(response => {
          this.updateRows(response, 'update', props.index)
        })
        .catch(response => {
          this.$modal.show('dialog', {
            title: 'Error!',
            text: response.data.message
          })
        })
    }

    onOpenImportModal() {
      if (!this.actionImportFile) {
        this.$modal.show('import-modal')
      } else if (
        typeof this.actionImportFile === 'function' &&
        this.actionImportFile()
      ) {
        this.$router.push('/import-courses-csv')
      }
    }

    onOpenImportModalForUsers() {
      let schoolId = localStorage.getItem('schoolId');
      if (schoolId) {
        this.$router.push('/import-users-csv')
      } else {
        this.$swal({
          type: 'error',
          title: 'Oops...',
          text: 'Please first select a school from the top dropdown.'
        })
        return false
      }
    }

    onImportFile() {
      if (
        this.$refs.importFile &&
        this.$refs.importFile.files instanceof FileList &&
        this.$refs.importFile.files.length > 0
      ) {
        PapaParse.parse(this.$refs.importFile.files[0], {
          complete: results => {
            // console.log('Finished:', results.data)
            const data = results.data
            const dataImport =
              typeof this.filterDataImport === 'function'
                ? this.filterDataImport(data)
                : { data }
            console.log('dataImport', dataImport)

            this.$http.post(`${this.baseUrl}/import`, dataImport).then(() => {
              typeof this.actionEndImportFile === 'function' &&
                this.actionEndImportFile()

              this.$swal({
                position: 'top-end',
                type: 'success',
                showConfirmButton: false,
                timer: 1500,
                title: 'All items has been submitted successfully.',
                toast: true
                // backdrop: false
              })
            })

            this.$modal.hide('import-modal')
            // self.msg.success('Import completed!')
            // self.props.importCoupons(self.props.params.post_id, results.data)
          }
        })
      }
    }

    // load items is what brings back the rows from server
    loadItems() {
      /* .$http({
              url: `${this.baseUrl}`,
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              }
          }) */
      this.$http
        .get(`${this.baseUrl}`, {
          params: this.serverParams
        })
        .then(response => {
          // handle success
          this.totalRecords = response.data.total // response.headers['x-total-count']
          this.rows = response.data.result
        })
        .catch(error => {
          // handle error
          console.log(error)
        })
        .then(() => {
          // always executed
        })
    }

    onSaveItem() {
      if (this.$refs.formData.validate()) {
        const id = this.dataSelectedRow._id
        const requestMethod = id ? 'put' : 'post'
        const dataEncoded = qs.stringify(this.formattedData())

        if (requestMethod === 'put') {
          this.$http
            .put(`${this.baseUrl}/${id}`, dataEncoded)
            .then(response => {
              this.updateRows(
                response,
                'update',
                this.dataSelectedRow.originalIndex
              )
            })
            .catch(response => {
              this.$swal({
                type: 'error',
                title: 'Oops...',
                text: response.data.message
              })
            })
        } else if (requestMethod === 'post') {
          this.$http
            .post(`${this.baseUrl}`, dataEncoded)
            .then(response => {
              this.updateRows(response, 'add', this.dataSelectedRow.originalIndex)
            })
            .catch(response => {
              /* this.$modal.show('dialog', {
                              title: 'Error!',
                              text: response.data.message
                          }) */
              this.$swal({
                type: 'error',
                title: 'Oops...',
                text: response.data.message
                // footer: '<a href>Why do I have this issue?</a>'
              })
            })
        }
      }
    }

    updateRows(response, type, index) {
      if (
        response.data &&
        response.data.success === true &&
        response.data.result
      ) {
        if (type === 'add') {
          this.rows.push(response.data.result)
        } else if (type === 'update') {
          this.rows.splice(index, 1, response.data.result)
        }
        this.hideFormModal()

        this.$swal({
          position: 'top-end',
          type: 'success',
          showConfirmButton: false,
          timer: 1500,
          title: 'The record has been saved.',
          toast: true
          // backdrop: false
        })

        if (typeof this.afterSaveHook === 'function') {
          this.afterSaveHook(response.data.result)
        }
      } else if (response.data && response.data.success === false) {
        // Handle validation errors (API returns 200 with success: false)
        this.$swal({
          type: 'error',
          title: 'Validation Error',
          text: response.data.message || 'Please check your input and try again.'
        })
        
        // Don't hide modal - let user fix the error
        // Don't call afterSaveHook for validation errors
      }
    }

    onDelete(props) {
      this.$modal.show('dialog', {
        title: 'Alert!',
        text: 'Are you sure?',
        buttons: [
          {
            title: 'Confirm Delete!',
            handler: () => {
              if (props.row && props.row._id) {
                this.$http
                  .delete(`${this.baseUrl}/${props.row._id}`)
                  .then(response => {
                    if (response.data && response.data.success === true) {
                      this.rows.splice(props.row.originalIndex, 1)
                      this.$modal.hide('dialog')
                    } else if (response.data.success === false) {
                      this.$swal({
                        type: 'error',
                        title: 'Oops...',
                        text: response.data.message
                      })
                    }
                  })
              }
            }
          },
          {
            title: 'Cancel',
            default: true
          }
        ]
      })
    }

    onValidated(isValid) {
      this.isValidForm = isValid
    }

    onRowDoubleClick(params) {
      // console.log(params)
      this.showFormModal(params)
    }

    onModelUpdated(newVal, schema) {
      // newVal is the value, and schema is the path for the property on the model
      this.$emit('modelUpdated', schema, newVal)
    }

    showFormModal(props = {}) {
      console.log(props)
      this.isValidForm = false
      if (props.row) {
        this.modalTitle = 'Edit'
        // this.formOptions.validateAfterLoad = true
        this.isNewModel = false
        this.$http.get(`${this.baseUrl}/${props.row._id}`).then(response => {
          this.dataSelectedRow = { ...props.row, ...response.data.result }
          this.$emit('setModeSchema', 'update')
          setTimeout(() => {
            this.$modal.show(`form-modal-${this.id}`)
            // this.$refs.formModal.toggle()
          })
        })
      } else {
        this.modalTitle = 'Add'
        // this.formOptions.validateAfterLoad = false
        this.isNewModel = true
        this.dataSelectedRow = VueFormGenerator.schema.createDefaultObject(
          this.schema,
          {}
        )
        this.$emit('setModeSchema', 'add')
        setTimeout(() => {
          this.$modal.show(`form-modal-${this.id}`)
          // this.$refs.formModal.toggle()
        })
      }
    }

    hideFormModal() {
      this.$modal.hide(`form-modal-${this.id}`)
    }

    openDinamicViewModal(props = {}) {
      const dinamicView = props.column.dinamicView
      this.currentModalComponent.width = dinamicView.modalWidth
      this.currentModalComponent.title = dinamicView.modalTitle
      this.currentModalComponent.component = dinamicView.component
      this.currentModalComponent.componentProps = {
        ...(dinamicView.componentProps ? dinamicView.componentProps : {}),
        id: props.row._id
      }

      setTimeout(() => {
        this.$modal.show(`dinamic-view-modal-${this.id}`)
        console.log('this.$refs.dinamicViewModal', this.$refs.dinamicViewModal)
        // this.$refs.dinamicViewModal.show()
      })
    }

    getFieldDataSelectedRow(fieldName) {
      if (this.dataSelectedRow && this.dataSelectedRow[fieldName]) {
        return this.dataSelectedRow[fieldName]
      }
    }

    setFieldDataSelectedRow(fieldName, value) {
      if (this.dataSelectedRow) {
        this.dataSelectedRow[fieldName] = value
      }
    }

    formattedData() {
      let dataFormatted = {}

      this._.map(this.schema.fields, item => {
        dataFormatted[item.model] = this._.get(this.dataSelectedRow, item.model)
      })

      return dataFormatted
    }

    @Watch('dataSelectedRow', { immediate: false, deep: true })
    changeDataSelectedRow(val) {
      this.$emit('changeDataModel', val)
    }
  }
</script>

<style lang="scss" scoped>
  .yt-grid-table {
    /deep/ .vgt-responsive {
      min-height: 500px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/common/GridTable.vue